// Données du site — Pharmacie La Lutrive
// Source de vérité partagée par toutes les sections du site vitrine.

export const SITE = {
    name: "Pharmacie La Lutrive",
    legalName: "Pharmacie La Lutrive Sàrl",
    tagline: "Pharmacie indépendante au cœur de Lutry",
    responsablePharmacien: "David Budan",
    address: {
        line1: "Grand-Rue 53",
        zip: "1095",
        city: "Lutry",
        region: "Vaud, Suisse",
    },
    phone: "+41 21 791 53 53",
    phoneDisplay: "021 791 53 53",
    email: "pharmacie@lalutrive.ch",
    website: "www.lalutrive.ch",
    presentation: [
        "À La Lutrive, nous avons imaginé une pharmacie de proximité où l'on prend le temps de conseiller, d'échanger et de trouver des solutions adaptées à chacun.",
        "Notre équipe met son expérience, son enthousiasme et son savoir-faire au service de votre santé, avec le plaisir de vous accueillir dans un environnement chaleureux et accessible.",
    ],
    hours: [
        { day: "Lundi – Vendredi", time: "08h00 – 18h30" },
        { day: "Samedi", time: "08h00 – 17h00" },
    ],
    mapsEmbed:
        "https://www.google.com/maps?q=Grand-Rue+53%2C+1095+Lutry%2C+Suisse&output=embed",
    mapsLink:
        "https://www.google.com/maps/place/Grand-Rue+53,+1095+Lutry,+Suisse",
    social: {
        instagram: "https://www.instagram.com/pharmacie.lalutrive?dlrf=MTZ2cDF1a281bHFzcg==",
    },
};

// Quick-access cards on the hero
export const HERO_QUICK_LINKS = [
    {
        key: "services",
        label: "Nos prestations",
        sub: "Vaccinations, dépistages, conseils",
        href: "#services",
    },
    {
        key: "rdv",
        label: "Prendre rendez-vous",
        sub: "Vaccins, entretiens, dépistages",
        href: "/rendez-vous",
    },
    {
        key: "contact",
        label: "Nous contacter",
        sub: "Téléphone, e-mail, itinéraire",
        href: "#contact",
    },
];

// Categorized prestations
export const SERVICE_CATEGORIES = [
    {
        key: "vaccinations",
        title: "Vaccinations",
        icon: "Syringe",
        intro:
            "Vaccinés directement à la pharmacie par nos pharmaciens autorisés par le canton de Vaud.",
        items: [
            "Grippe",
            "Covid",
            "Encéphalite à tiques",
            "Hépatite A (uniquement deuxième dose)",
            "Hépatite B (uniquement deuxième dose)",
            "Rougeole *",
            "Oreillons *",
            "Coqueluche (uniquement deuxième dose)",
            "Herpès Zoster — zona (uniquement deuxième dose)",
        ],
        footnote:
            "* Selon les recommandations du canton de Vaud en vigueur (doses de rappel).",
    },
    {
        key: "prevention",
        title: "Prévention & dépistages",
        icon: "Activity",
        intro:
            "Mesures rapides et confidentielles, avec interprétation par votre pharmacien.",
        items: [
            "Test glycémie",
            "Mesure de la tension artérielle",
            "Oxymétrie",
        ],
    },
    {
        key: "conseils",
        title: "Consultations & conseils pharmaceutiques",
        icon: "Stethoscope",
        intro:
            "Un conseil humain, personnalisé et fondé sur les meilleures pratiques pharmaceutiques.",
        items: [
            "Médicaments sur ordonnance — délivrance sécurisée",
            "Conseil pharmaceutique personnalisé",
            "Entretien de polymédication",
            "Parapharmacie : soins, hygiène, nutrition, bien-être",
            "Santé familiale — enfants, adultes, seniors",
            "Suivi thérapeutique",
            "Soin des plaies",
            "Remise de médicaments sur ordonnance possible sans prescription (sous conditions)",
            "Prolongation d'un traitement chronique",
            "Remise de la pilule du lendemain",
            "Conseil voyage",
            "Aide à l'arrêt du tabac",
            "Accompagnement diabète",
        ],
    },
    {
        key: "complementaires",
        title: "Médecines complémentaires",
        icon: "Leaf",
        intro:
            "Une approche globale, qui complète et soutient les traitements conventionnels.",
        items: [
            "Phytothérapie",
            "Aromathérapie",
            "Homéopathie",
            "Micronutrition",
            "Fleurs de Bach",
            "Gemmothérapie",
        ],
    },
    {
        key: "autres",
        title: "Autres services",
        icon: "Sparkles",
        intro:
            "Des petits plus du quotidien, pensés pour vous simplifier la vie.",
        items: [
            {
                title: "Confort et mobilité",
                description:
                    "Fauteuil roulant *, cannes, bas de contention — disponibles de suite à la pharmacie. Autres aides à la mobilité et moyens auxiliaires disponibles rapidement sur commande. Renseignez-vous auprès de notre équipe !",
            },
            "Mesure des bas de contention",
            "Perçage d'oreilles",
            "Livraison à domicile (selon conditions locales)",
        ],
        footnote: "* CHF 99.– dans le cadre d'une participation AVS.",
    },
];

// Cosmetic brand range — logos when available, typographic name as fallback
export const COSMETIC_BRANDS = [
    { name: "La Roche-Posay", logo: "/brands/larochepossay.webp" },
    { name: "SVR", logo: "/brands/svr.webp" },
    { name: "La Rosée", logo: "/brands/larosee.svg" },
    { name: "Filorga", logo: "/brands/filorga.webp" },
    { name: "Baija", logo: "/brands/baija.webp" },
    { name: "L'Alpage", logo: "/brands/lalpage.webp" },
    { name: "MKL", logo: "/brands/mkl.webp" },
    { name: "Gloriel", logo: "/brands/gloriel.webp" },
    { name: "Rausch", logo: "/brands/rausch.webp" },
    { name: "Mavala", logo: "/brands/mavala.webp" },
    { name: "Poderm", logo: "/brands/poderm.webp" },
];

// Emergency / off-hours
export const EMERGENCY = {
    pharmacie24: {
        name: "Pharmacie 24",
        address: "Avenue de Montchoisi 24, 1006 Lausanne",
        phone: "+41 21 613 12 24",
        phoneDisplay: "021 613 12 24",
        hours: "08h00 – minuit, 7j/7",
        logoSrc: "/pharmacie24.png",
    },
    gardeLink: {
        label: "Trouver la pharmacie de garde la plus proche",
        href: "https://garde.svph.ch/",
    },
    centraleMedecins: {
        label: "Centrale des médecins de garde",
        phone: "+41 848 133 133",
        phoneDisplay: "0848 133 133",
    },
};

// Access info (parking + transport)
export const ACCESS_INFO = {
    parkingNote: "Stationnements (durée 30min) à proximité",
    parking: [
        "Parking Quai Vaudaire (3min)",
        "Parking de la Possession (5min)",
    ],
    transport: [
        "Train CFF : gare de Lutry (ligne S4 / S5)",
        "Bus tl ligne 9 — arrêt Voisinand",
    ],
};

export const TEAM_STATS = [
    { value: "100%", label: "Conseil personnalisé" },
    { value: "5★", label: "Médecines complémentaires" },
    { value: "9", label: "Vaccins proposés" },
    { value: "7j/7", label: "Service de garde cantonal" },
];

// Photos of the pharmacy — used in About, Gallery, Contact
export const PHARMACY_PHOTOS = {
    interior: "/img/interior-1280.webp",       // interior with wheelchair + green neon caduceus
    shelvesWide: "/img/shelves-2-1280.webp",   // wide interior with branded shelves
    shelves: "/img/shelves-1-1280.webp",        // narrower panoramic
    exterior: "/img/exterior-1280.webp",       // exterior with green cross
    street: "/img/street-1280.webp",           // wider street view
    corner: "/img/corner-1280.webp",           // corner with entrée par le côté sign
    mobility: "/img/mobility-1280.webp",       // crutches / canes
    wheelchair: "/img/wheelchair-1280.webp",   // single wheelchair by neon
};

// Team — group photo + individual descriptions
export const TEAM_GROUP_PHOTO = "/img/group-1280.webp";

export const TEAM_BIOS = [
    {
        name: "David",
        role: "Pharmacien responsable",
        bio: "Toujours à l'écoute et animé par une grande passion pour son métier, David apporte à La Lutrive son regard attentif, son expérience et son calme rassurant. Il partage chaque jour son énergie positive et son sens du conseil.",
    },
    {
        name: "Catherine",
        role: "Associée - gérante",
        bio: "Passionnée et profondément investie dans cette nouvelle aventure, Catherine apporte à La Lutrive sa fraîcheur, son dynamisme et son sens de l'organisation au quotidien. Elle aime le travail d'équipe, les projets menés avec enthousiasme et le plaisir de créer un lieu accueillant et vivant.",
    },
    {
        name: "Sylvia",
        role: "Associée - gérante",
        bio: "Très attachée à Lutry, où elle a grandi, Sylvia a imaginé La Lutrive comme un lieu chaleureux, bienveillant et profondément humain. Elle aime avant tout les échanges, le contact avec les gens et l'énergie d'une équipe soudée partageant les mêmes valeurs.",
    },
    {
        name: "Corinne",
        role: "Assistante en pharmacie",
        bio: "Très attachée à Lutry et à ses habitants, Corinne accompagne les clients avec douceur, simplicité et bonne humeur. Son expérience, sa proximité et son regard attentif font d'elle une présence précieuse au sein de l'équipe.",
    },
    {
        name: "Alena",
        role: "Pharmacienne adjointe",
        bio: "Curieuse, enthousiaste et passionnée par la pharmacie de proximité, Alena rejoint La Lutrive avec l'envie de construire une relation simple et authentique avec les clients. Elle apporte à l'équipe sa fraîcheur, son dynamisme et son sourire.",
    },
];

export const NEWS = [
    {
        slug: "vaccination-grippe-2025",
        tag: "Prévention",
        date: "15 oct. 2025",
        title: "Campagne de vaccination grippe 2025",
        excerpt:
            "Dès le 15 octobre, vaccinez-vous directement à la pharmacie, sans rendez-vous. Remboursé par l'assurance de base si prescrit.",
        cover:
            "https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?auto=format&fit=crop&w=1400&q=70",
        body: [
            "La grippe saisonnière touche chaque année des milliers de personnes en Suisse romande. La vaccination reste le moyen le plus efficace pour se protéger, en particulier pour les personnes de plus de 65 ans, les femmes enceintes et les personnes fragiles.",
            "À la Pharmacie La Lutrive, nos pharmaciens sont autorisés par le canton de Vaud à vacciner directement, sans ordonnance, dans un espace dédié et confidentiel.",
            "Prenez rendez-vous en ligne ou passez simplement nous voir — nous vous accueillons du lundi au samedi.",
        ],
    },
    {
        slug: "allergies-printemps",
        tag: "Conseil",
        date: "24 mars 2025",
        title: "Allergies de printemps : nos solutions naturelles",
        excerpt:
            "Pollens, yeux qui piquent, éternuements… Découvrez notre sélection de traitements homéopathiques et allopathiques pour traverser la saison sereinement.",
        cover:
            "https://images.unsplash.com/photo-1490818387583-1baba5e638af?auto=format&fit=crop&w=1400&q=70",
        body: [
            "Avec le réchauffement précoce, la saison pollinique démarre souvent dès fin février. Les graminées, bouleaux et cyprès sont les principaux responsables des rhinites allergiques.",
            "Nos conseils : lavage nasal quotidien à l'eau de mer, antihistaminiques H1 nouvelle génération pour la journée, et compléments en quercétine ou vitamine C pour soutenir le terrain.",
            "Passez en cabine pour un bilan personnalisé — nous adaptons votre traitement à votre quotidien.",
        ],
    },
    {
        slug: "voyage-trousse",
        tag: "Voyages",
        date: "12 juin 2025",
        title: "Votre trousse santé pour partir en voyage",
        excerpt:
            "Antipaludiques, désinfectants, anti-moustiques, médicaments de base… Nous préparons avec vous une trousse adaptée à votre destination.",
        cover:
            "https://images.unsplash.com/photo-1488085061387-422e29b40080?auto=format&fit=crop&w=1400&q=70",
        body: [
            "Chaque destination a ses spécificités : tropiques, haute altitude, zones rurales. Nous consultons pour vous les recommandations officielles de Swisstropical et du CECIV.",
            "Notre checklist couvre : prophylaxie antipaludique, vaccins conseillés, traitement de l'eau, protection solaire adaptée UV 50+, répulsifs DEET 30–50 %.",
            "Présentez-nous votre billet, nous préparons votre trousse en 48h.",
        ],
    },
];

// Responsive srcset for photos exported as -640 / -1280 webp pairs
export const LEGAL = {
    company: "Pharmacie La Lutrive Sàrl",
    legalForm: "Société à responsabilité limitée (Sàrl)",
    uid: "CHE-451.917.371",
    commerceRegister: "CH-550.1.254.831-3",
    vat: "CHE-451.917.371 TVA",
    responsible: "La direction de la Pharmacie La Lutrive",
    host: "Emergent Labs Inc. (États-Unis)",
    studio: "Studio by G",
    studioUrl: "https://studio-by-g.ch",
    updated: "juin 2026",
};

export const photoSrcSet = (src) =>
    [640, 960, 1280].map((w) => `${src.replace("-1280.webp", `-${w}.webp`)} ${w}w`).join(", ");
